<template>
  <div class="hello" style="background-color:#f5f5f5f8; height:auto; padding-bottom: 120px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false">
          <template #right>
            <van-icon style="margin-bottom:10px; margin-right: 5px;" name="bell" color="#FFFFFF" size="30" />
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;">
      <div v-if="userData.name" style="margin-left:15px; display: inline-flex">
        <van-image width="50px" height="50px" :src="picture" round></van-image>
        <div style="margin-left:5px;">
          <span style="font-weight: 700; font-size:1rem; color:#FFFFFF">{{ userData.name }}</span><br>
          <van-tag color="#FFFFFF"><van-image width="10px" height="10px" src="/static/icon_fb.svg" round></van-image><span style="color:black; font-weight: 700">FB登入中</span></van-tag>
        </div>
      </div>
    </div>
    <van-cell-group style="border-radius:20px; margin-top:-70px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:20px; height:120px;" size="large" >
        <van-grid :border="false" style="margin-top:15px;">
          <van-grid-item to="/order">
            <van-image src="/static/icon_order.svg" width="32px" height="32px"></van-image>
            <span style="font-weight:400; font-size:14px;">訂單查詢</span>
          </van-grid-item>
          <van-grid-item to="/address">
            <van-image src="/static/icon_address.svg" width="32px" height="32px"></van-image>
            <span style="font-weight:400; font-size:14px;">收貨資料</span>
          </van-grid-item>
          <van-grid-item to="/coupon">
            <van-image src="/static/icon_coupon.svg" width="32px" height="32px"></van-image>
            <span style="font-weight:400; font-size:14px;">卡券中心</span>
          </van-grid-item>
          <van-grid-item to="/cart">
            <van-image src="/static/icon_cart.svg" width="32px" height="32px"></van-image>
            <span style="font-weight:400; font-size:14px;">購物車</span>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:20px; margin-top:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title"><van-icon name="fire-o" />好物推介</span>
        </template>
      </van-cell>
      <van-cell class="recomm-cell" :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in recomm" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
  </div>
</template>
<script>
import { getInfo } from '@/api/user'
import { getUser, getFBToken, removeToken, removeUser } from '@/utils/auth'
import { getItemRecommend } from '@/api/item'
import { Toast } from 'vant'

export default {
  name: '',
  data () {
    return {
      picture: '',
      userData: {},
      recomm: []
    }
  },
  watch: {

  },
  created () {
    this.getUser()
    this.getRecommendInfo()
  },
  methods: {
    gotohome () {
      this.$router.push({ path: '/' })
      window.scrollTo(0, 0)
    },
    getRecommendInfo () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getItemRecommend({ code: '', nums: 12 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    },
    getUser () {
      getInfo({ user: getUser(), token: getFBToken() }).then(res => {
        if (res.code === 200) {
          this.picture = res.data.avatar
          this.userData = res.data
        } else {
          removeToken()
          removeUser()
          this.$router.push({ path: '/login' })
        }
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Member.vue